import { PlusOutlined } from '@ant-design/icons';
import { FloatButton } from 'antd';
import React from 'react';
import styled from 'styled-components';

type ActionButtonsProps = {
  onAddToMenu: () => void;
};

const ActionButtons = ({ onAddToMenu }: ActionButtonsProps) => {
  return (
    <ButtonContainer>
      <FloatButton
        tooltip='Add food to menu'
        onClick={onAddToMenu}
        icon={<PlusOutlined />}
        type='primary'
        style={{ right: 24 }}
      />
    </ButtonContainer>
  );
};

export default ActionButtons;
const ButtonContainer = styled.div`
  .ant-float-btn-body {
    background-color: #e44391;
  }
  &:hover .ant-float-btn-body {
    background-color: #f5479b;
  }
`;
